export default class ItemManufacturerModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id;
			this.name = data.name;
			this.description = data.description;
		}
	}

	id = 0;
	name = "";
	description: string | null = null;
}